<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">To Kyle, for putting up with</p>
<p class="ded1">a summer full of</p>
<p class="ded1">inconvenient working hours.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?3f81a346